function getPayments(params) {
    return ApiClient.get('/payments/methods', params);
}

function getAllPayments(params) {
    const codes = [];
    let pagination;

    const fetchPayments = async function (offset) {
        const response = await getPayments(offset ? { ...params, offset } : params);

        response.data.data.forEach(code => codes.push(code));
        pagination = response.data.pagination;

        if (pagination.count === pagination.limit) {
            return await fetchPayments(pagination.offset);
        }
        return codes;
    }

    return new Promise(async (resolve, reject) => {
        let allRows;
        await fetchPayments(null).then(function (rows) {
            allRows = rows;
        }).catch(reject);

        resolve(allRows);
    });
}

export default {
    getPayments,
    getAllPayments
}